import { sendGAEvent } from "@next/third-parties/google";
import { getOrCreateVisitorId } from "./storageUtils";

export const sendAnalytics = (event_name, payload = {}, language = "en") => {
    if (typeof window === "undefined") return; 

    let urlParams = JSON.parse(localStorage.getItem("urlParams")) || {};

    let combined_payload = {
        page_language: language,
        entireUrl: urlParams?.entire_url ?? "",
        referrer_Url: document?.referrer ? document?.referrer : "direct",
        visitor_id: getOrCreateVisitorId(),
        user_id: getOrCreateVisitorId(),
        ...payload,
    };
    sendGAEvent('event', event_name, combined_payload )
};
